module.exports = __webpack_public_path__ + "assets/img/4910f950c31f01932398e3ed0e67006a.svg";